import React from "react";
import { Line } from "react-chartjs-2";
import LeasingService from "../services/LeasingService";
import Moment from "moment";

const Chart = (props) => {
  const [monthLabels, setMonthData] = React.useState([]);
  const [rentAmount, setRentAmountData] = React.useState([]);
  const [homeSharingAmount, setHomeSharingAmountData] = React.useState([]);
  const [currentMonthRevenueAmount, setcurrentMonthRevenueAmount] =
    React.useState(0);
  // const [last12MonthRevenue, setlast12MonthRevenue] = React.useState(0);
  const [netRevenue, setnetRevenue] = React.useState(0);
  const [lifeTimeRent, setLifeTimeRent] = React.useState(0);
  const [currentMonthRent, setCurrentMonthRent] = React.useState(0);
  const [rentPaidByOH, setRentPaidByOh] = React.useState(0);
  const propertySlug = props.propertySlug ? props.propertySlug : "";
  const { selectedMonth, selectedYear } = props;

 React.useEffect(() => {
    const PropertyRentdata = async () => {
      // Build query string with filters
      let queryParams = [];
      
      if (propertySlug) {
        queryParams.push("property_slug=" + propertySlug);
      }
      
      if (selectedMonth && selectedYear) {
        queryParams.push(`month=${selectedYear}-${selectedMonth}`);
      } else if (selectedYear) {
        queryParams.push(`year=${selectedYear}`);
      } else if (selectedMonth) {
        // If only month is selected, use current year
        const currentYear = Moment().format('YYYY');
        queryParams.push(`month=${currentYear}-${selectedMonth}`);
      }
      
      const queryString = queryParams.length > 0 ? queryParams.join('&') : '';
      
      let res = await LeasingService.getPropertyRent(queryString);
      if (global.successStatus.includes(res.status)) {
        setRentAmountData(res.data.rentAmount ? res.data.rentAmount : []);
        setHomeSharingAmountData(
          res.data.homeSharingAmount ? res.data.homeSharingAmount : []
        );
        setMonthData(res.data.monthName ? res.data.monthName : []);
        setcurrentMonthRevenueAmount(
          res.data.currentMonthRevenueAmount
            ? res.data.currentMonthRevenueAmount
            : 0
        );
        setnetRevenue(res.data.netRevenue ? res.data.netRevenue : 0);
        setLifeTimeRent(res.data.lifeTimeRent ? res.data.lifeTimeRent : 0);
        setCurrentMonthRent(
          res.data.currentMonthRent ? res.data.currentMonthRent : 0
        );
        setRentPaidByOh(
          res.data.rentPaidByOH ? res.data.rentPaidByOH : 0
        )
      }
    };
    PropertyRentdata();
  }, [propertySlug, selectedMonth, selectedYear]);

  const lineChartData = {
    labels: monthLabels,
    datasets: [
      {
        label: "Collected Rent",
        data: rentAmount,
        tension: 0.1,
        backgroundColor: "#2c504661",
        borderColor: "#2c5046",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#2c5046",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#2c5046",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        borderWidth: 3,
      },
      {
        label: "Home Sharing Income + Collected Rent",
        data: homeSharingAmount,
        borderWidth: 3,
        fill: true,
        borderColor: "#ea3e91",
        backgroundColor: "#ea3e911a",
      },
    ],
  };

  const getChartTitle = () => {
    return "Property Rent Collection";
  };

  return (
    <div>
      <div className="container p-0">
        <div className="az-content-body p-0">
          <div className="media media-dashboard-one">
            <div className="media-body m-0">
              <div className="card card-minimal-two">
                <div className="card-body dashborad_chart">
                  <div className="flot-wrapper ml-0 pd-lg-r-20 pd-lg-l-20">
                    <div className="d-flex justify-content-between mg-b-0">
                      <div className="card-header overview_heading border-0 mb-0">
                        {/* <h4 className="mb-0">Property Rent collection</h4> */}
                        <h4 className="mb-0">{getChartTitle()}</h4>
                      </div>
                      <div className="chart-legend">
                        <div>
                          <span className="bg-chat-pink"></span> Home Sharing
                          Income + Collected Rent
                        </div>
                        <div>
                          <span className="bg-chart-green"></span> Collected
                          Rent
                        </div>
                      </div>
                    </div>
                    <div className="chart_box_fix">
                      <Line
                        options={{
                          maintainAspectRatio: false,
                          axisY: {
                            title: "Bounce Rate",
                            suffix: "%",
                          },
                          axisX: {
                            title: "Week of Year",
                            prefix: "W",
                            interval: 2,
                          },
                          scales: {
                            yAxes: [
                              {
                                display: true,
                                ticks: {
                                  // Include a dollar sign in the ticks
                                  callback: function (value, index, ticks) {
                                    return value
                                      ? "$" +
                                          global.onKeyPressEvent.numberWithCommasForDecimal(
                                            parseFloat(value)
                                              .toFixed(2)
                                              .replace(/\.00$/, "")
                                          )
                                      : 0;
                                  },
                                  minor: {
                                    fontSize: 16,
                                    fontFamily: "Lato-Regular",
                                  },
                                },
                              },
                            ],
                            xAxes: [
                              {
                                display: true,
                                position: "bottom",
                                ticks: {
                                  minor: {
                                    fontSize: 16,
                                    fontFamily: "Lato-Regular",
                                  },
                                },
                              },
                            ],
                          },
                          legend: {
                            display: false,
                            position: "top",
                          },
                          elements: {
                            point: {
                              radius: 0,
                            },
                            line: {
                              tension: 0,
                            },
                          },
                          tooltips: {
                            callbacks: {
                              label: function (tooltipItem, data) {
                                const datasetLabel =
                                  data.datasets[tooltipItem.datasetIndex].label;
                                return (
                                  datasetLabel +
                                  ": $" +
                                  global.onKeyPressEvent.numberWithCommasForDecimal(
                                    tooltipItem.yLabel
                                  )
                                );
                              },
                            },
                          },
                        }}
                        data={lineChartData}
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="media">
                    <div className="media-body">
                      <div className="row row-sm">
                        <div className="col">
                          <label>
                            Current Month Revenue(Home Sharing Income +
                            Collected Rent)
                          </label>
                          <p>
                            {currentMonthRevenueAmount
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(currentMonthRevenueAmount)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div>
                        {/* <div className="col">
                          <label>
                            last 12 Month (Home Sharing Income + Collected Rent)
                          </label>
                          <p>
                            {last12MonthRevenue
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(last12MonthRevenue)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div> */}
                        <div className="col">
                          <label>
                            LifeTime Revenue(Home Sharing Income + Collected
                            Rent)
                          </label>
                          <p>
                            {netRevenue
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(netRevenue)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div>
                      </div>

                      <div className="row row-sm mb-3">
                        <div className="col">
                          <label>Current Month Collected Rent</label>
                          <p>
                            {currentMonthRent
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(currentMonthRent)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div>

                        <div className="col">
                          <label>LifeTime Collected Rent</label>
                          <p>
                            {lifeTimeRent
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(lifeTimeRent)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div>
                      </div>
                      <div className="row row-sm">
                        <div className="col">
                          <label>Rent Paid by OH</label>
                          <p>
                            {rentPaidByOH
                              ? "$" +
                                global.onKeyPressEvent.numberWithCommasForDecimal(
                                  parseFloat(rentPaidByOH)
                                    .toFixed(2)
                                    .replace(/\.00$/, "")
                                )
                              : 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Chart;
